
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/ueberuns/infrastruktur/infrastruktur-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="infrastruktur-view">
        <hero-section
            background-image="/images/hero/infrastruktur-hero.png"
            headline="Unsere Infrastruktur"
            subheadline="Infrastruktur mit FASE2"
            text="Die starke Vernetzung unserer Unternehmensgruppe ermöglicht<br>schnelle Reaktionszeiten und eine effiziente Ressourcenplanung."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="unsere-infrastruktur">
                <hex-headline id="unsere-infrastruktur" left text="Unsere Infrastruktur – FASE2 Facility Services"></hex-headline>
                <p>
                    Hinter <b>FASE2 Facility Services</b> steht eine starke und gut vernetzte Infrastruktur, die es uns ermöglicht, 
                    Ihnen einen <b>umfassenden Service</b> aus einer Hand zu bieten. 
                    Wir arbeiten eng mit renommierten Unternehmen zusammen, die in ihren jeweiligen Bereichen 
                    <b>höchste Standards</b> setzen und über jahrelange Erfahrung verfügen. Dies garantiert Ihnen <b>Qualität</b>, 
                    Zuverlässigkeit und einen <b>reibungslosen Ablauf</b> bei allen Projekten rund um Ihre <b>Immobilie</b>.
                </p>
            </article>

            <hr>

            <article aria-labelledby="laudani-gmbh">
                <hex-headline id="laudani-gmbh" left text="Laudani GmbH – Ihr Partner für Sanierungen und Instandhaltungen"></hex-headline>
                <p>
                    Die <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> ist seit über 25 Jahren ein führender Anbieter für <b>Immobiliensanierungen</b> und Instandhaltungsarbeiten in <b>Köln und Umgebung</b>. 
                    Mit ihrem umfangreichen Know-how und der <b>langjährigen Expertise</b> im Bereich Gebäudesanierung hat sich die <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> 
                    einen exzellenten Ruf aufgebaut. Von der <b>Komplettsanierung</b> über Renovierungen bis hin zur <b>Wartung und Pflege</b> Ihrer Immobilie – 
                    bei der <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> erhalten Sie alles aus einer Hand.
                </p>
            </article>

            <hr>

            <article aria-labelledby="cleanodino">
                <hex-headline id="cleanodino" left text="cleanodino – Maßstäbe in der Gebäudereinigung"></hex-headline>
                <p>
                    Die <a href="https://cleanodino.de/" target="_blank">cleanodino Gebäudereinigung</a> setzt in Leverkusen und Umgebung neue <b>Maßstäbe</b> im Bereich der professionellen Gebäudereinigung. 
                    Mit einem <b>Fokus</b> auf nachhaltige Reinigungsprozesse, höchste <b>Hygienestandards</b> und einem Team von hochqualifizierten 
                    Reinigungskräften bieten wir <b>erstklassige Dienstleistungen</b> für Privatpersonen und <b>Unternehmen</b>. <a href="https://cleanodino.de/" target="_blank">cleanodino</a> sorgt dafür, 
                    dass Ihre <b>Immobilie</b> nicht nur sauber, sondern auch <b>gepflegt</b> und einladend bleibt.
                </p>
            </article>

            <hr>

            <article aria-labelledby="cleano-shop">
                <hex-headline id="cleano-shop" left text="Cleano Shop – Ihr Partner für Reinigungsmittel und Ausstattungen"></hex-headline>
                <p>
                    Mit dem "<a href="https://www.der-cleanoshop.de/" target="_blank">Der Cleanoshop</a>" bieten wir Ihnen zudem alles, was Sie für eine professionelle <b>Reinigung</b> benötigen. 
                    Ob Reinigungsmittel, <b>Ausrüstungen</b> oder Zubehör – hier finden Sie eine <b>große Auswahl</b> an Produkten, 
                    die in der <b>Gebäudereinigung</b> und Sanierung verwendet werden. <a href="https://www.der-cleanoshop.de/" target="_blank">Der Cleanoshop</a> steht für hohe Qualität, 
                    <b>Zuverlässigkeit</b> und faire Preise.
                </p>
            </article>

            <hr>

            <article aria-labelledby="netzwerk-partner">
                <hex-headline id="netzwerk-partner" left text="Netzwerk aus Fachpartnern und Handwerkern"></hex-headline>
                <p>
                    Neben diesen etablierten <b>Unternehmen</b> sind Salvatore Laudani und Hüseyin Sidar auch in zahlreichen Unternehmernetzwerken vertreten. 
                    Diese langjährige <b>Vernetzung</b> mit Fachleuten aus unterschiedlichen Bereichen ermöglicht es uns, 
                    auf ein <b>riesiges Netzwerk</b> von Handwerkern und <b>Partnern</b> zuzugreifen. So können wir Ihnen nicht nur schnelle 
                    Lösungen für Ihre <b>Sanierungs-</b> und <b>Reinigungsprojekte</b>, sondern auch maßgeschneiderte Konzepte für die <b>Instandhaltung</b>, 
                    Modernisierung und <b>Wartung</b> Ihrer Immobilie bieten.
                </p>
            </article>

            <hr>

            <article aria-labelledby="logistik">
                <hex-headline id="logistik" left text="Logistischer Vorteil durch strategische Lagerflächen"></hex-headline>
                <p>
                    Durch die <b>Vielzahl an Unternehmen</b> im Hintergrund ergibt sich ein weiterer entscheidender Vorteil: 
                    <b>FASE2 Facility Services</b> verfügt über strategisch platzierte Lagerflächen in verschiedenen <b>Standorten in NRW</b>. 
                    Diese ermöglichen es uns, die benötigten Materialien, Werkzeuge und Ausstattungen schnell und effizient bereitzustellen 
                    und die <b>Einsätze vor Ort</b> noch optimierter und <b>effektiver</b> zu gestalten. Dank dieser logistischen Kapazitäten können wir 
                    Ihnen noch <b>schnellere Reaktionszeiten</b> und eine höhere Flexibilität bieten – und das bedeutet für Sie weniger 
                    Ausfallzeiten und eine <b>reibungslose Abwicklung</b> von Projekten. Diese <b>Effizienz</b> kommt natürlich nicht nur uns zugute, 
                    sondern auch Ihnen und Ihren Objekten.
                </p>
            </article>

            <hr>

            <article aria-labelledby="alles-aus-einer-hand">
                <hex-headline id="alles-aus-einer-hand" left text="Unser Anspruch: Alles aus einer Hand"></hex-headline>
                <p>
                    Dank dieser <b>soliden Infrastruktur</b> und unserem umfassenden Netzwerk können wir Ihnen bei <b>FASE2 Facility Services</b> 
                    einen einmaligen Vorteil bieten: Alle Belange Ihrer <b>Immobilie</b> aus einer Hand. Egal, ob es um Sanierung, 
                    <b>Reinigung</b> oder die Bereitstellung von Reinigungsmitteln geht – wir sind Ihr <b>kompetenter Partner</b> für alles, 
                    was Ihre Immobilie betrifft.
                </p>
            </article>
        </div>
    </section>`,
      style: `infrastruktur-view .infrastruktur-view {
  margin: 0;
  padding: 0;
}
infrastruktur-view .infrastruktur-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
infrastruktur-view .infrastruktur-view .wrapper article {
  margin: 96px 0 0 0;
  padding: 0;
}
infrastruktur-view .infrastruktur-view .wrapper article:first-of-type {
  margin: 0 0 0 0;
}
infrastruktur-view .infrastruktur-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  infrastruktur-view .infrastruktur-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  